import {
  USER_SIGNIN_FAIL,
  USER_SIGNIN_REQUEST,
  USER_SIGNIN_SIGNOUT,
  USER_SIGNIN_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_RESET,
  USER_UPDATE_PROFILE_SUCCESS,
} from '../constant/userConstant';

interface UserSigninState {
  loading?: boolean;
  userInfo?: any;
  error?: string;
}

export const userSigninReducer = (state: UserSigninState = {}, action: any) => {
  switch (action.type) {
    case USER_SIGNIN_REQUEST: {
      return { loading: true };
    }

    case USER_SIGNIN_SUCCESS: {
      return { loading: false, userInfo: action.payload };
    }

    case USER_SIGNIN_FAIL: {
      return { loading: false, error: action.payload };
    }

    case USER_SIGNIN_SIGNOUT: {
      return {};
    }

    default:
      return state;
  }
};

interface UserRegisterState {
  loading?: boolean;
  userInfo?: any;
  error?: string;
}

export const userRegisterReducer = (state: UserRegisterState = {}, action: any) => {
  switch (action.type) {
    case 'USER_REGISTER_REQUEST': {
      return { loading: true };
    }

    case 'USER_REGISTER_SUCCESS': {
      return { loading: false, userInfo: action.payload };
    }

    case 'USER_REGISTER_FAIL': {
      return { loading: false, error: action.payload };
    }

    default:
      return state;
  }
};

interface UserDetailsState {
  loading?: boolean;
  user?: any;
  error?: string;
}

export const userDetailsReducer = (state: UserDetailsState = {}, action: any) => {
  switch (action.type) {
    case 'USER_DETAILS_REQUEST': {
      return { loading: true };
    }
    case 'USER_DETAILS_SUCCESS': {
      return { loading: false, user: action.payload };
    }
    case 'USER_DETAILS_FAIL': {
      return { loading: false, error: action.payload };
    }
    default:
      return state;
  }
};

// ------Tipos ---------------------------------------------------------------
interface UserUpdateProfileState {
  loading?: boolean;
  success?: boolean;
  error?: string;
}

interface UserUpdateProfileSuccessActions {
  type: typeof USER_UPDATE_PROFILE_SUCCESS;
}

interface UserUpdateProfileFailActions {
  type: typeof USER_UPDATE_PROFILE_FAIL;
  payload: string;
}

interface UserUpdateProfileResetActions {
  type: typeof USER_UPDATE_PROFILE_RESET;
}
interface UserUpdateProfileRequestAction {
  type: typeof USER_UPDATE_PROFILE_REQUEST; //
}

interface UserUpdateProfileSuccessAction {
  // ✅ sin 's' al final
  type: typeof USER_UPDATE_PROFILE_SUCCESS;
}

interface UserUpdateProfileFailAction {
  // ✅ sin 's' al final
  type: typeof USER_UPDATE_PROFILE_FAIL;
  payload: string;
}

interface UserUpdateProfileResetAction {
  // ✅ sin 's' al final
  type: typeof USER_UPDATE_PROFILE_RESET;
}
type UserUpdateProfileActions =
  | UserUpdateProfileRequestAction
  | UserUpdateProfileSuccessAction
  | UserUpdateProfileFailAction
  | UserUpdateProfileResetAction;

// ── Reducer ───────────────────────────────────────────────────────────────────

/**
 * @reducer userUpdateProfileReducer
 * @description Maneja el estado de la actualización del perfil de usuario.
 *
 * ┌─────────────────────────────────────────────────────────────────┐
 * │  Estado           │  Descripción
 * ├─────────────────────────────────────────────────────────────────┤
 * │  {}               │  Estado inicial / reseteado
 * │  loading: true    │  Petición en curso
 * │  success: true    │  Actualización exitosa
 * │  error: string    │  Mensaje de error del servidor
 * └─────────────────────────────────────────────────────────────────┘
 */

export const userUpdateProfileReducer = (
  state: UserUpdateProfileState = {},
  action: any
): UserUpdateProfileState => {
  switch (action.type) {
    case USER_UPDATE_PROFILE_REQUEST:
      return { loading: true };

    case USER_UPDATE_PROFILE_SUCCESS:
      return { loading: false, success: true };

    case USER_UPDATE_PROFILE_FAIL:
      return { loading: false, error: action.payload };

    case USER_UPDATE_PROFILE_RESET:
      return {};

    default:
      return state;
  }
};
